import lscache from 'lscache'

// enable warnings
if (process.env.NODE_ENV !== 'production') {
  lscache.enableWarnings(true)
}

const storageKey = 'MetricaSportsDownloadApp'
const localStorageService = {}

// Set data
localStorageService.set = (key, data, duration = undefined) =>
  lscache.set(`${storageKey}-${key}`, data, duration)

// Get data
localStorageService.get = key => lscache.get(`${storageKey}-${key}`)

// Delete data
localStorageService.delete = () => lscache.flush()

export default localStorageService
